
import { defineComponent } from 'vue'
import DProfile from './desktop/DProfile.vue'
import Logo from './Logo.vue'
import Locale from './desktop/Locale.vue'
import { subpages } from '@/data/navigation/subpages'
import { langs } from '@/data/navigation/langs'

interface Subpage {
  text: string
  link?: string
  links?: {
    en: string
    jp: string
    kr: string
  }
  scrollTo?: string
}

export default defineComponent({
  data(): { subpages: Subpage[]; langs: typeof langs } {
    return {
      subpages,
      langs,
    }
  },
  components: {
    Logo,
    DProfile,
    Locale,
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    subpagesWithScrollTo(): Subpage[] {
      return this.subpages.filter((subpage: Subpage) => subpage.scrollTo)
    },
    subpagesWithoutScrollTo(): Subpage[] {
      return this.subpages.filter((subpage: Subpage) => !subpage.scrollTo)
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    smoothScroll(subpage: Subpage) {
      if (subpage.scrollTo) {
        const targetElement = document.getElementById(subpage.scrollTo)
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
    isLanguageKey(key: string): key is 'en' | 'jp' | 'kr' {
      return ['en', 'jp', 'kr'].includes(key)
    },
    getLinkForCurrentLanguage(subpage: Subpage) {
      if (subpage.links && this.isLanguageKey(this.currentLanguage)) {
        return subpage.links[this.currentLanguage]
      }
      return '#'
    },
  },
})
